import { ProductVariantAvailability, StockPolicy } from './graphql/graphql'

export function isAvailableForPurchase(
  availability?: ProductVariantAvailability | null,
): boolean {
  if (!availability) return false
  if (!availability.availableForPurchase) return false

  return (
    availability.stockPolicy == StockPolicy.NotTracked ||
    availability.availableQuantity > 0
  )
}
